// theme/assets/dialog.js — slice-7
// Trimmed lift from Shopify/horizon assets/dialog.js. Native <dialog> wrapper
// that dispatches DialogOpenEvent / DialogCloseEvent. Used by cart-drawer.js.

// Bun (test env) has no HTMLElement; fall back to plain class so imports don't throw.
const _HTMLElement = globalThis.HTMLElement ?? class {};

export class DialogOpenEvent extends Event {
  static eventName = 'dialog:open';
  constructor() { super(DialogOpenEvent.eventName, { bubbles: true }); }
}

export class DialogCloseEvent extends Event {
  static eventName = 'dialog:close';
  constructor() { super(DialogCloseEvent.eventName, { bubbles: true }); }
}

export class DialogComponent extends _HTMLElement {
  get #dialog() {
    return this.querySelector('dialog');
  }

  connectedCallback() {
    this.#dialog?.addEventListener('close', this.#onNativeClose);
  }

  disconnectedCallback() {
    this.#dialog?.removeEventListener('close', this.#onNativeClose);
  }

  #onNativeClose = () => {
    this.dispatchEvent(new DialogCloseEvent());
  };

  showDialog() {
    const dialog = this.#dialog;
    if (!dialog || dialog.open) return;
    dialog.showModal();
    this.dispatchEvent(new DialogOpenEvent());
  }

  closeDialog() {
    const dialog = this.#dialog;
    if (!dialog || !dialog.open) return;
    dialog.close(); // triggers 'close' → dispatches DialogCloseEvent
  }
}
